import { textValue } from './enrollmentStatistics';

// Usar o dia informado pela Sponte, sem conversão de fuso que possa trocar a data.
export function parseEnrollmentDate(value) {
  const text = textValue(value);
  const iso = /^(\d{4})-(\d{2})-(\d{2})(?:$|T|\s)/.exec(text);
  const br = /^(\d{2})\/(\d{2})\/(\d{4})(?:$|\s)/.exec(text);
  if (!iso && !br) return null;
  const [year, month, day] = iso ? iso.slice(1).map(Number) : [Number(br[3]), Number(br[2]), Number(br[1])];
  if (year < 1900 || year > 9999) return null;
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
export const displayDate = value => value ? value.split('-').reverse().join('/') : '—';
export function periodError(period) {
  if (!period?.start || !period?.end) return 'Informe a data inicial e a data final.';
  if (!parseEnrollmentDate(period.start) || !parseEnrollmentDate(period.end)) return 'Informe datas válidas.';
  if (period.start > period.end) return 'A data final deve ser igual ou posterior à data inicial.';
  return '';
}
export function campaignPeriod(period, selectedYear, targetYear) {
  if (!period) return null;
  if (periodError(period)) throw new Error(periodError(period));
  let adjusted = false;
  const shift = value => {
    const [year, month, day] = value.split('-').map(Number);
    const target = year + Number(targetYear) - Number(selectedYear);
    const lastDay = new Date(Date.UTC(target, month, 0)).getUTCDate();
    if (day > lastDay) adjusted = true;
    return `${target}-${String(month).padStart(2, '0')}-${String(Math.min(day, lastDay)).padStart(2, '0')}`;
  };
  const start = shift(period.start),
    end = shift(period.end);
  if (!parseEnrollmentDate(start) || !parseEnrollmentDate(end)) throw new Error('Período fora do intervalo de datas suportado.');
  return {
    start,
    end,
    adjusted,
    days: Math.round((Date.parse(end) - Date.parse(start)) / 86400000) + 1
  };
}
export const emptyMetrics = () => ({
  total: 0,
  new: 0,
  returning: 0,
  unknown: 0
});
export function inPeriodMetrics(classroom, range) {
  const totals = emptyMetrics();
  Object.entries(classroom.daily || {}).forEach(([date, values]) => {
    if (date >= range.start && date <= range.end) for (const key of Object.keys(totals)) totals[key] += values[key];
  });
  return totals;
}
export function periodCurve(annual) {
  const days = Math.max(...annual.map(row => row.range?.days || 0));
  if (!days) return [];
  const step = Math.max(1, Math.ceil((days - 1) / 59));
  const offsets = [...new Set([...Array.from({
    length: Math.ceil(days / step)
  }, (_, i) => i * step), days - 1])];
  return offsets.map(offset => {
    const point = {
      day: offset + 1
    };
    annual.forEach(row => {
      point[row.year] = !row.available ? null : row.classrooms.reduce((sum, classroom) => sum + Object.entries(classroom.daily || {}).reduce((count, [date, values]) => {
        const elapsed = Math.round((Date.parse(date) - Date.parse(row.range.start)) / 86400000);
        return count + (date >= row.range.start && date <= row.range.end && elapsed <= offset ? values.total : 0);
      }, 0), 0);
    });
    return point;
  });
}
